import useAIConfiguration from "ai/hooks/useAIConfiguration";
import useWidgetSummaryAvailability from "ai/hooks/useWidgetSummaryAvailability";
const useWidgetSummaryUnavailableReason = (widgetType) => {
  var _a;
  const { data: availability, isLoading: loadingAvailability } = useWidgetSummaryAvailability(widgetType);
  const { data: aiConfig, isLoading: loadingAIConfig } = useAIConfiguration();
  if (loadingAIConfig || (aiConfig == null ? void 0 : aiConfig.isEnabled) !== true) {
    return "AI features are disabled by the administrator.";
  }
  if (loadingAvailability) {
    return "Checking whether summaries are available ...";
  }
  if (!availability.available) {
    return (_a = availability.message) != null ? _a : "Widget summaries are not available.";
  }
  return void 0;
};
export default useWidgetSummaryUnavailableReason;
